import React from "react";
import Footer from "../components/Partials/Footers/HomeOne/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="privacy-policy-hero">
        <div className="privacy-policy-hero-content">
          <h1 className="privacy-policy-hero-title">Politika e Privatësisë</h1>
          <div className="privacy-policy-hero-subtitle">
            Mbrojtja e të dhënave tuaja personale është prioriteti ynë
          </div>
          <div className="privacy-policy-update-badge">
            <span className="update-icon">📅</span>
            <span className="update-text">
              Përditësimi i fundit: 11 Gusht 2025
            </span>
          </div>
        </div>
      </div>

      <div className="privacy-policy-container">
        <div className="privacy-policy-content">
          <div className="privacy-policy-section">
            <div className="section-header">
              <div className="section-icon">🔒</div>
              <h2 className="privacy-policy-subtitle">
                Procesimi i të Dhënave Personale
              </h2>
            </div>
            <div className="section-content">
              <p className="privacy-policy-text">
                Regjistrimi dhe përdorimi i shërbimeve të platformës Balotazhi
                është falas. Llogaria e përdoruesit është personale dhe nuk
                duhet të ndahet me të tjerët. Ne i ruajmë informacionet tuaja
                për ta bërë përvojën tuaj në platformën tonë më efikase dhe
                relevante. Ju mund të rishikoni, përditësoni ose fshini
                informacionet e profilit tuaj në çdo kohë duke u kyçur në
                llogarinë tuaj.
              </p>
              <p className="privacy-policy-text">
                Për të krijuar një llogari, kërkohet që përdoruesit të japin një
                adresë të vlefshme emaili dhe të caktojnë një fjalëkalim të
                sigurt. Përdoruesi është plotësisht përgjegjës për ruajtjen e
                konfidencialitetit të fjalëkalimit. Platforma Balotazhi nuk mban
                përgjegjësi për çdo përdorim të paautorizuar të llogarisë së
                përdoruesit. Të dhënat tuaja personale janë të qasshme vetëm nga
                stafi i autorizuar i Balotazhi.
              </p>
            </div>
          </div>

          <div className="privacy-policy-section">
            <div className="section-header">
              <div className="section-icon">📊</div>
              <h2 className="privacy-policy-subtitle">
                Përdorimi dhe Përditësimi i të Dhënave
              </h2>
            </div>
            <div className="section-content">
              <p className="privacy-policy-text">
                Balotazhi mund t'i përpunojë të dhënat tuaja personale për
                qëllime të marketingut të drejtpërdrejtë, si dhe për krijimin e
                analizave, raporteve ose materialeve të tjera promocionale
                brenda platformës sonë. Në çdo rast, ju do të keni gjithmonë
                opsionin për t'u ç'regjistruar nga marrja e informacioneve të
                tilla. Është përgjegjësia juaj t'i mbani të dhënat tuaja të
                sakta dhe të përditësuara.
              </p>
            </div>
          </div>

          <div className="privacy-policy-section">
            <div className="section-header">
              <div className="section-icon">⚖️</div>
              <h2 className="privacy-policy-subtitle">
                Të Drejtat Tuaja si Subjekt i të Dhënave
              </h2>
            </div>
            <div className="section-content">
              <p className="privacy-policy-text">
                Në përputhje me legjislacionin në fuqi, ju keni të drejtë të
                kërkoni qasje në të dhënat tuaja personale, të kërkoni
                korrigjimin, plotësimin apo fshirjen e tyre. Gjithashtu, keni të
                drejtë të kundërshtoni përpunimin ose të kërkoni kufizimin e
                tij. Këto të drejta ushtrohen në masën që nuk bien ndesh me
                detyrimet ligjore ose interesin publik.
              </p>
              <div className="contact-highlight">
                <p className="privacy-policy-text">
                  Një kërkesë për ushtrimin e të drejtave tuaja mund të bëhet
                  duke na shkruar në adresën e emailit:{" "}
                  <a
                    href="mailto:privatesia@balotazhi.com"
                    className="privacy-policy-link"
                  >
                    privatesia@balotazhi.com
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>

          <div className="privacy-policy-section">
            <div className="section-header">
              <div className="section-icon">📝</div>
              <h2 className="privacy-policy-subtitle">
                Ndryshimet në Politikën e Privatësisë
              </h2>
            </div>
            <div className="section-content">
              <p className="privacy-policy-text">
                Për çdo ndryshim thelbësor në politikën tonë të privatësisë, ne
                do të publikojmë një njoftim të qartë në faqen tonë kryesore.
                Çdo ndryshim hyn në fuqi 30 ditë kalendarike pas publikimit të
                tij. Vazhdimi i përdorimit të shërbimeve tona pas kësaj periudhe
                nënkupton pajtueshmërinë tuaj me politikat e reja.
              </p>
            </div>
          </div>

          <div className="privacy-policy-section">
            <div className="section-header">
              <div className="section-icon">📧</div>
              <h2 className="privacy-policy-subtitle">Na Kontaktoni</h2>
            </div>
            <div className="section-content">
              <p className="privacy-policy-text">
                Nëse keni ndonjë pyetje në lidhje me këtë politikë të
                privatësisë, ju lutemi mos hezitoni të na kontaktoni përmes
                emailit në:{" "}
                <a
                  href="mailto:info@balotazhi.com"
                  className="privacy-policy-link"
                >
                  info@balotazhi.com
                </a>
                .
              </p>
            </div>
          </div>

          <div className="privacy-policy-footer">
            <div className="footer-content">
              <div className="footer-icon">🛡️</div>
              <p className="footer-text">
                <strong>Balotazhi</strong> - Kompromisi ynë për privatësinë tuaj
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
